import $ from 'jquery';
import videojs from 'video.js';

import config from './globals/config';

import videoLoad from './video-load';
import videoEvents from './video-events';
import videoInteract from './video-interact';

export default function (loadingSpinner, videoId, location, poster) {
  let videoControls;

  if (location === 'main') {
    if (config.trailerPlayer !== null) {
      config.myPlayer = null;
      config.trailerPlayer = null;
    }

    if (config.myPlayer === null) {
      if (config.theWindow.width() > 640) {
        if (config.currentPage === 'homepage') {
          videoControls = $('.trailer-drawer-ui');
        } else {
          videoControls = $('#playerLightbox .trailer-drawer-ui');
        }

        videojs('myDesktopPlayer').ready(function () {
          let myPlayerEvents = new videoEvents(this, 'main');

          if (config.currentPage === 'homepage') {
            this.volume(0);

            config.isMute = true;
          }

          this.on('ended', function () {
            myPlayerEvents.setNextActive();
            if (poster) {
              poster.loadNext();
            }
          });
          this.on('timeupdate', function () {
            myPlayerEvents.setCurrentTime();
          });
          this.on('durationchange', function () {
            loadingSpinner.hide();
            myPlayerEvents.setDurationTime();
          });
          this.on('loadeddata', function () {
            if (poster) {
              poster.fadeOut();
            }
            loadingSpinner.hide();
            myPlayerEvents.setDurationTime();
          });
          this.on('waiting', function () {
            loadingSpinner.show();
          });
          this.on('seeking', function () {
            loadingSpinner.show();
          });
          this.on('seeked', function () {
            loadingSpinner.hide();
          });
          this.on('progress', function () {
            loadingSpinner.hide();
          });
          this.on('fullscreenchange', function () {
            if ( this.isFullscreen_ ) {
              $('#playerLightbox').addClass('is-fullscreen');
            } else {
              $('#playerLightbox').removeClass('is-fullscreen');
            }
          });

          this.on('pause', function () {
            let pause = videoControls.find('.pause');

            pause.addClass('hide');
            pause.parent().find('.play').removeClass('hide');
          });
          this.on('play', function () {
            let play = videoControls.find('.play');

            play.addClass('hide');
            play.parent().find('.pause').removeClass('hide');
          });

          let trailersJSON = config.featuredTrailersJSON;

          let options = {
            title      : trailersJSON[config.currentTrailerNum].post_title,
            description: trailersJSON[config.currentTrailerNum].post_excerpt,
            deeplinking: false,
            offset     : '00:00:00',
            services   : {
              facebook : true,
              google   : true,
              twitter  : true,
              tumblr   : true,
              linkedin : false,
              pinterest: false,
            },
          };
          this.social(options);

          config.myPlayer = this;

          videoLoad(loadingSpinner, videoId, this);

          videoInteract(videoControls, this);

          if (config.currentPage === 'homepage') {
            videoControls.find('input[type="range"]').rangeslider({ polyfill: false });
          }

        });
      } else {
        videojs('myMobilePlayer').ready(function () {
          config.myPlayer = this;

          config.myPlayer.on('loadeddata', function () {
            loadingSpinner.hide();
          });

          videoLoad(loadingSpinner, videoId, this);
        });
      }
    } else {
      videoLoad(loadingSpinner, videoId, config.myPlayer);
    }
  } else if (location === 'trailer') {
    config.myPlayer = null;

    if ( config.theWindow.width() > 640 && !( $('body').hasClass('home') && (config.isiPad || config.isAndroid) ) ) {
      videojs('trailerPlayer').ready(function () {

        let videoControls = $('#trailerModal .trailer-drawer-ui');

        let myPlayerEvents = new videoEvents(this, 'trailer');

        this.on('timeupdate', function () {
          myPlayerEvents.setCurrentTime();
        });
        this.on('durationchange', function () {
          loadingSpinner.hide();
          myPlayerEvents.setDurationTime();
        });
        this.on('loadeddata', function () {
          loadingSpinner.hide();
          myPlayerEvents.setDurationTime();
        });
        this.on('waiting', function () {
          loadingSpinner.show();
        });
        this.on('seeking', function () {
          loadingSpinner.show();
        });
        this.on('seeked', function () {
          loadingSpinner.hide();
        });
        this.on('progress', function () {
          loadingSpinner.hide();
        });

        this.on('pause', function () {
          let pause = videoControls.find('.pause');

          pause.addClass('hide');
          pause.parent().find('.play').removeClass('hide');
        });
        this.on('play', function () {
          let play = videoControls.find('.play');

          play.addClass('hide');
          play.parent().find('.pause').removeClass('hide');
        });
        this.on('fullscreenchange', function () {
          if ( this.isFullscreen_ ) {
            $('#trailerModal').addClass('is-fullscreen');
          } else {
            $('#trailerModal').removeClass('is-fullscreen');
          }
        });

        config.myPlayer = this;
        config.trailerPlayer = this;

        videoLoad(loadingSpinner, videoId, this);

        videoInteract(videoControls, this);

        videoControls.find('input[type="range"]').rangeslider({ polyfill: false });
      });
    } else { // mobile trailer player
      videojs('mobileTrailerPlayer').ready(function () {
        config.myPlayer = this;
        config.trailerPlayer = this;

        config.myPlayer.on('loadeddata', function () {
          loadingSpinner.hide();
        });

        videoLoad(loadingSpinner, videoId, this);
      });
    }
  }
}
